import {
  TwitterIcon,
  FacebookIcon,
  ShareIcon,
} from '../icons'
import { facebookAppId } from '../../stv.config'

const shareItems = [
  {
    name: 'facebook',
    icon: FacebookIcon,
    title: 'Share on Facebook',
    url: `https://www.facebook.com/dialog/share?app_id=${facebookAppId}&display=popup&href=URL_REPLACE`,
    width: '35px',
    height: '35px',
    popup: true,
  },
  {
    name: 'twitter',
    icon: TwitterIcon,
    title: 'Share on Twitter',
    url: `https://twitter.com/intent/tweet?text=${encodeURIComponent("I've just watched TITLE_REPLACE on STV Player")}&url=URL_REPLACE`,
    width: '21px',
    height: '21px',
    popup: true,
  },
  {
    name: 'email',
    icon: ShareIcon,
    title: 'Share by email',
    url: `mailto:?subject=I've just watched TITLE_REPLACE on STV Player&body=Visit URL_REPLACE`,
    width: '32px',
    height: '32px',
    popup: false,
  },
]

export default shareItems
